import loadable from '@loadable/component';

export const CmsRecommendedActionsBlockLoadable = loadable(
  () => import('./CmsRecommendedActionsBlock'),
  { resolveComponent: (module) => module.CmsRecommendedActionsBlock },
);
